// handlebars helper from i18next
import i18next from 'i18next';
import Handlebars from 'handlebars';

export default function(key, options) {
  let result = i18next.t(key, options.hash);
  return new Handlebars.SafeString(result);
}
